import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings({
    en: {
        company: 'Kleer Digital',
        error_loginExpired: 'Login expired.',
        error_generic: 'An error ocurred. Please try again later.',
        error_provideName: "Please provide your full name",
        error_provideAgency: "Please provide the name of your agency",
        error_provideEmail: "Please provide your email address",
        error_invalidEmail: "Invalid Email. Please provide a valid email address",
        error_invalidFirstName: "Invalid First Name. Please provide your first name",
        error_invalidLastName: "Please provide your last name",
        error_invalidAddress: "Invalid Address. Please provide a valid address",
        error_invalidCity: "Invalid City. Please provide a valid city",
        error_invalidZip: "Invalid Zipcode. Please provide a valid Zipcode",
        error_invalidCountry: "Please provide a valid country",
        error_invalidLogin: "Invalid Login. The email/password combination did not work.  Please re-enter your email and password.",
        error_emailNotFound: "Email not found",
        error_emailAlreadyExisting: "Email already existing",
        error_providePassword: "Please provide a password",
        error_passwordNotMeetingRequirement: "Your password should have at least 6 characters",
        error_passwordNotMatch: "The passwords do not match",
        error_acceptTC: "You need to accept our Terms and Conditions",
        error_provideCode: "Please enter your verification code",
        error_codeInvalid: "The entered code is invalid",
        error_cardNumberRequired: "Please provide a credit card number",
        error_expRequired: "Please provide an expiration date",
        error_expInvalid: "Invalid Expiration Date. Please provide a valid expiration date",
        error_cvvRequired: "Please provide a CVV number",
        error_noCreditCard: "No credit card associated",
        info_codeWasSent: "We sent you a nother verification code",

        learn_more: "Learn more",
        share: 'Share',
        get_started: 'Get Started',
        upgrade: 'Upgrade',
        subscribe_now: 'Subscribe now',
        subscribed_to: 'Subscribed to ',
        cancel: 'Cancel',
        current_plan: 'Current Plan',
        sign_in: 'Sign In',
        sign_up: 'Sign Up',
        or_sign_up: 'or Sign Up',
        checkout: 'Checkout',
        logout: 'Logout',
        login: 'Login',
        welcome: 'Welcome',
        pricing: 'Pricing',
        termsAndConditions: 'Terms and Conditions',
        dashboard: 'Dashboard',
        fullName: 'Full Name',
        emailAddress: 'Email Address',
        password: 'Password',
        code: 'Code',
        verify: 'Verify',
        back: 'Back',
        welcomeBack: 'Welcome back!',
        manageSubscription: 'Manage Subscription',
        done: 'Done',
        no: 'No',
        changePassword: 'Change Password',
        settings: 'Settings',
        agency: 'Agency',
        accountInfo: 'Account Info',
        facebook: 'Facebook',
        googleAnalytics: 'Google Analytics',
        googleAdwords: 'Google Adwords',
        accessDenied: 'Access Denied',
        clients: 'Clients',
        reports: 'Reports',
        agencyReport: 'Agency Report',
        save: 'Save',

        accountUpdated: 'Account sucessfully updated',

        sign_up_accept_tc: 'I accept the Terms and Conditions',
        sign_up_repeatPassword: 'Repeat Password',
        sign_up_welcome: 'Welcome to Kleer Digital. Click here to learn more!',

        address_firstName: 'First Name',
        address_lastName: 'Last Name',
        address_line2: 'Address line 2',
        address_line1: 'Address line 1',
        address_city: 'City',
        address_state: 'State',
        address_zip: 'Zip / Postal code',
        address_country: 'Country',

        verify_weSendACode: 'We send you a verification code to your email address',
        verify_title: 'Verify your email address',
        verify_resend: 'Resend Code',

        pricing_description: 'Select the plan which meets your requirements',

        checkout_paymentMethod: 'Payment Method',
        checkout_billingAddress: 'Billing Address',
        checkout_next: 'Next',
        checkout_subscribe: 'Subscribe',
        checkout_package: 'Package',
        checkout_interval: 'Interval',
        checkout_pricing: 'Pricing',
        checkout_cardHolder: 'Card Holder',
        checkout_cardType: 'Card type',
        checkout_cardNumber: 'Card number',
        checkout_cardExp: 'Expiry date',
        checkout_errorSubscriptionAlreadyExisting: 'You are already subscribed. Please cancel or change your membership.',
        checkout_errrorPleaseSelectPlanAndProduct: 'Please select a plan and a interval',
        checkout_errorUsingCreditCard: 'An error ocurred using this credit card. Please add a new credit card.',
        checkout_subscriptionSuccess: 'Thanks for subscribing!',
        checkout_coupon: 'Coupon',

        payment_cardNumber: 'Card number',
        payment_expiryDate: 'Expiry date',
        payment_cvv: 'CVV',
        payment_cvv_hint: 'Last three digits on signature strip',
        payment_nameOnCard: 'Name on card',

        info_currentSubscription: 'Current Subscription',
        upgrade_subTitle: 'Upgrade now!',
        cancel_membership: 'Cancel Membership',
        cancel_membershipSubTitle: 'Cancel Membership now or at next renewal',
        cancel_membershipDescription: 'Do you really want to cancel your susbcription?',
        cancel_now: 'Cancel now',
        cancel_atNextRenewal: 'Cancel at next renewal',
        cancel_novalidSusbcriptionFound: 'No valid susbscription found',
        cancel_sucess: 'Subscription sucessfully cancelled',

        newClient_nameMissing: 'Please specify a name',
        newClient_name: 'Name',
        newClient_logo: 'Logo',
        newClient_frequency: 'Report Frequency',
        newClient_addedAt: 'Added At',

        client_datasource: 'Datasources',
        client_runReports: 'Run Reports',
        client_admin: 'Admin',
        client_connectDatasource: 'Connect Datasource',

        client_noClientsYet: 'You have no clients yet.',
        client_addFirstClient: 'Add your first client',
        client_noClientSelecteed: 'No client selected',
        client_pleaseSelectClient: 'Please select a client to run a report',

        client_deleteAreYouSure: 'Are you sure?',
        client_deleteAction: 'Delete',
        client_deleteDescription: 'Delete this client',
        client_uploadAction: 'Upload',
        client_uploadLogo: 'Upload a Logo',

        datasource_addGoogleDescription: 'Add your Google Analytics account',
        datasource_addGoogleAdwordsDescription: 'Add your Google Adwords account',
        datasource_addFacebookDescription: 'Add your Facebook account',
        datasource_disconnect: 'Disconnect',
        datasource_connectFacebookPage: 'Connect the facebook page of this client',
        datasource_connectGoogleAnalyticsView: 'Connect the google analytics view of this client',
        datasource_connectGoogleAdwordsView: 'Connect the google adwords view of this client',
        datasource_connectInSettings: 'Please connect/reconnect in Settings'
    }
});
export default strings


// WEBPACK FOOTER //
// ./src/strings.ts